import api from '../http-common';

const getIndexData = (url, data?) =>
  api.post<FutureContractsOptionsType>(`/ace/${url}/get-index-data`, data)

const getMarginList = (url, data?) =>
  api.post<FutureContractType[]>(`/ace/${url}/index`, data)

const getDataTradingMonth = (url, data?) =>
  api.post<FutureContractType[]>(`/ace/${url}-custom/index`, data)

const getContractsData = () =>
  api.post('/contracts/get-index-data')

const getContractData = (id: string) =>
  api.post(`/contracts/${id}/show`)

const getStoneXContracts = (data) =>
  api.post('/contracts/index', data)

const getStoneXContractsCount = (data) =>
  api.post<StoneXCountType[]>('/contracts/count', data)

const getContractsOptions = () =>
  api.post('/contracts/get-options-data')

const updateContract = (id: string, data) =>
  api.post(`/contracts/${id}/update`, data)

const getContractComments = (id: string, data) =>
  api.post(`/contracts/${id}/comments/list`, data)

const storeContractComment = (id: string, data) =>
  api.post(`/contracts/${id}/comments/store`, data)

const deleteContractComment = (id: string, idComment) =>
  api.post(`/contracts/${id}/comments/${idComment}/delete`)

const updateContractComment = (id: string, idComment, data) =>
  api.post(`/contracts/${id}/comments/${idComment}/update`, data)

const FutureContractsService = {
  getIndexData,
  getMarginList,
  getDataTradingMonth,
  getContractsData,
  getStoneXContracts,
  getStoneXContractsCount,
  getContractsOptions,
  updateContract,
  getContractComments,
  storeContractComment,
  updateContractComment,
  deleteContractComment,
  getContractData
};
export interface FutureContractType {
  createdAt: string
  currency: string
  month: number
  netChange: number
  settlement: number
  symbol: string
  timestamp: string
  year: number
  expiryMonth?: number
  expiryYear?: number
}

type SymbolType = {
  slug: string;
  abbreviation: string;
  label: string;
};

type FutureContractsOptionsType = {
  dates: string[];
  symbols: SymbolType[];
};

export type StoneXCountType = {
  count: number;
  status: number;
  statusLabel: string;
  type: string;
}

export default FutureContractsService;
